import { SETTINGS_SERVICE } from "@/services/settings.service.js";
import router from '@/router/index';

const state = { settingsOutput: {}, updateProgress: false};

const actions = {
    editSettings({ dispatch, commit }, inputSettings) {
        dispatch('alert/clear', null, { root: true });
        commit('editRequest');
        SETTINGS_SERVICE.edit(inputSettings)
            .then(
                output => {
                    commit('editSuccess', output);
                },
                error => {
                    commit('editFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    getSettings({ dispatch, commit }) {
        dispatch('alert/clear', null, { root: true });
        commit('getRequest');

        SETTINGS_SERVICE.get()
            .then(
                output => {
                    commit('getSuccess', output);
                },
                error => {
                    commit('getFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    }
};

const mutations = {
    /* Edit */
    editRequest(state) {
        state.updateProgress = undefined;
    },
    editSuccess(state) {
        state.updateProgress = true;
    },
    editFailure(state) {
        state.updateProgress = false;
    },
    /* Get */
    getRequest(state) {
        //
    },
    getSuccess(state, output) {
        state.settingsOutput = output;
    },
    getFailure(state) {
        state.settingsOutput = {};
    },
};

export const settings = {
    namespaced: true,
    state,
    actions,
    mutations
};